<template>
  <div>
    <v-dialog v-model="newClassDialog" max-width=600>
      <v-card>
        <v-card-title>
          <span class="headline">New Schoolwide Account</span>
        </v-card-title>
        <v-card-text>
          <form v-on:keyup.enter="createNewClass">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 v-if="createClassError">
                  <v-alert
                    :value="createClassError"
                    type="error"
                    outline
                  >
                    {{ createClassError }}
                  </v-alert>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Username" v-model="dialogUsername" required outline></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Password" v-model="dialogPassword" required outline></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat v-on:click="newClassDialog = false">Cancel</v-btn>
          <v-btn color="secondary" v-on:click="createNewClass">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editClassroomDialog" max-width=600>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Account</span>
        </v-card-title>
        <v-card-text>
          <form v-on:keyup.enter="updateClassroom">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 v-if="editClassroomError">
                  <v-alert
                    :value="editClassroomError"
                    type="error"
                    outline
                  >
                    {{ editClassroomError }}
                  </v-alert>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Username" v-model="editDialogUsername" required outline></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field label="Password" v-model="editDialogPassword" required outline></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat v-on:click="editClassroomDialog = false">Cancel</v-btn>
          <v-btn color="secondary" v-on:click="updateClassroom">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width=300>
      <v-card>
        <v-card-title class="headline">Delete Account?</v-card-title>

        <v-card-text>
          <span class="subheading">Anyone using this account will no longer be able to sign in.</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat v-on:click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="secondary" v-on:click="deleteClass(classToDelete)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-for="(item, index) in classrooms">
      <v-layout :key="item.username" wrap>
          <v-flex xs12 mt-4 mb-2 v-if="index !== 0">
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs10>
            <v-layout wrap>
              <v-flex xs6 pl-2 my-1>
                Username
              </v-flex>
              <v-flex xs6 pl-2 my-1>
                Password
              </v-flex>
              <v-flex xs6 px-3 py-2 class="box text_content">
                {{ item.username }}
              </v-flex>
              <v-flex xs6 px-3 py-2 class="box text_content">
                {{ item.password }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2>
            <v-layout wrap v-if="isAdminUser">
              <v-flex xs12 my-1>
                &nbsp;
              </v-flex>
              <v-flex xs12 py-2 my-1>
                <v-icon
                  medium
                  v-on:click="prepareClassroomEdit(item)"
                >
                  edit
                </v-icon>
                <v-icon
                  medium
                  v-on:click="classToDelete = item.id; deleteDialog = true;"
                >
                  delete
                </v-icon>
              </v-flex>
            </v-layout>
          </v-flex>
      </v-layout>
    </template>
    <div class="text-xs-center mt-4" v-if="loading === false && classrooms.length === 0 && !isAdminUser">
      <v-alert
        :value="true"
        color="primary"
        outline
      >
        Your license Administrator has not yet created a Schoolwide account.
      </v-alert>
    </div>
    <div class="text-xs-center mt-4" v-if="loading === false && classrooms.length === 0 && isAdminUser">
      <v-alert
        :value="true"
        color="primary"
        outline
      >
        Click <strong>Add account</strong> to create a generic account for your school.
      </v-alert>
    </div>
    <div class="mt-4">
      <v-btn
        v-on:click="newClassDialog = true"
        v-if="isAdminUser"
        color="secondary"
      >
        + Add account
      </v-btn>
    </div>
  </div>
</template>

<script>
import { filter } from 'lodash'
import ClassroomService from '@/services/ClassroomService'

export default {
  components: {
  },
  data: function () {
    return {
      loading: false,
      isAdminUser: this.$store.getters.user.isAdminUser,
      classrooms: [],
      newClassDialog: false,
      dialogUsername: null,
      dialogPassword: null,
      createClassError: null,
      editClassroomDialog: false,
      classroomToUpdate: null,
      editDialogUsername: null,
      editDialogPassword: null,
      editClassroomError: null,
      deleteDialog: false,
      classToDelete: null
    }
  },
  mounted: function () {
    this.loadClassrooms();
  },
  methods: {
    async loadClassrooms () {
      this.loading = true
      try {
        const result = await ClassroomService.index();

        this.classrooms = filter(result.data, classroom => { 
          return classroom.SchoolId !== null; 
        })
      } catch (err) {
        console.log(err.response.data.error);
      }
      this.loading = false
    },
    async createNewClass () {
      const credentials = {
        username: this.dialogUsername, 
        password: this.dialogPassword
      };

      try {
        const result = await ClassroomService.createSchoolwideClassroom(credentials);

        this.classrooms.push(result.data)
        this.newClassDialog = false;
        this.dialogUsername = null;
        this.dialogPassword = null;
        this.createClassError = null;
      } catch (err) {
        this.createClassError = err.response.data.error;
      }
    },
    async deleteClass(classID) {
      try {
        await ClassroomService.delete(classID);
        
        this.classToDelete = null;
        this.deleteDialog = false;
        this.loadClassrooms();
      } catch (err) {
        console.log(err.response.data.error);
      }
    },
    prepareClassroomEdit (classroom) {
      this.classroomToUpdate = classroom;
      this.editDialogUsername = classroom.username;
      this.editDialogPassword = classroom.password;

      this.editClassroomDialog = true;
    },
    async updateClassroom() {
      const credentials = {
        username: this.editDialogUsername,
        password: this.editDialogPassword
      };

      try {
        await ClassroomService.put(this.classroomToUpdate.id, credentials);
        
        this.classroomToUpdate = null;
        this.editClassroomDialog = false;
        this.loadClassrooms();
      } catch (err) {
        this.editClassroomError = err.response.data.error;
      }
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #F5F5F5;
  border: 8px solid white;
  border-radius: 12px;
}

.text_content {
  font-family: "Lexend", sans-serif !important;
  font-weight: 300;
  font-size: 16px;
  color: #616161;
}
</style>
